<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baCheckoutExam:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="账单年份">
                <a-date-picker v-model="queryParam.billCycleYear"  :allowClear="false" :open='yearShowOne'  @openChange="openChangeOne" @panelChange="panelChangeOne"  format="YYYY"  mode="year"  placeholder="请选择年份" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单月份">
                <a-month-picker v-model="queryParam.billCycleMonth" allow-clear  format="MM"  placeholder="请选择月份" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单类型">
                <a-select v-model="queryParam.orderType"  allow-clear placeholder="请选择账单类型" :options="pharmacytypes"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
        :loading="loading"
      >
        <template class="table-operator" slot="operator" v-if="hasPerm('baCheckoutExam:add')" >
          <a-button type="primary" v-if="hasPerm('baCheckoutExam:add')" icon="plus" @click="$refs.addForm.add()">生成结账单</a-button>
          <x-down style="display: none;"
            v-if="hasPerm('baCheckoutExam:export')"
            ref="batchExport"
          />
        </template>

        
        <span slot="orderType" slot-scope="text, record">
          <span>{{ Number(record.orderType) == 0 ? '挂号' : Number(record.orderType) == 1 ? '处方' : Number(record.orderType) == 5 ? '体检' : '---'  }}</span>
        </span>
        <span slot="refundFee" slot-scope="text, record">
          <span style="color:red">{{ record.refundFee }}</span>
        </span>
        

        <span slot="action" slot-scope="text, record">
          <a v-if="hasPerm('baCheckoutExam:edit')" @click="batchExport(record)">导出</a>
          <a-divider type="vertical" v-if="hasPerm('baCheckoutExam:edit') & hasPerm('baCheckoutExam:delete')"/>
          <a v-if="hasPerm('baCheckoutExam:delete')" @click="$refs.detialFrom.add(record)">详情</a>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
      <detial-from ref="detialFrom"></detial-from>
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { baCheckoutExamPage, baCheckoutExamDelete, baCheckoutExamExport } from '@/api/modular/interhospital/bacheckoutexam/baCheckoutExamManage'
  import addForm from './addForm.vue'
import editForm from './editForm.vue'
  import detialFrom from './detialFrom.vue'
import { text } from 'body-parser'
import { number } from 'echarts'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      detialFrom,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        yearShowOne: false,
        loading : false,
        pharmacytypes:[
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '挂号',
          },
          {
            value: '1',
            label: '处方',
          },
          {
            value: '5',
            label: '体检',
          },
        ],
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '结账月份',
            align: 'center',
            dataIndex: 'billCycle'
          },
          {
            title: '结账人',
            align: 'center',
            dataIndex: 'checkoutUser'
          },
          {
            title: '结账日期',
            align: 'center',
            dataIndex: 'checkoutDate'
          },
          {
            title: '合计收款',
            align: 'center',
            dataIndex: 'chargeFee',
          },
          {
            title: '退款',
            align: 'center',
            dataIndex: 'refundFee',
            scopedSlots: { customRender: 'refundFee' },
          },
          {
            title: '实际收款',
            align: 'center',
            dataIndex: 'realFee',
          },
          {
            title: '账单类型',
            align: 'center',
            dataIndex: 'orderType',
            scopedSlots: { customRender: 'orderType' },
          },
          // {
          //   title: '是否已删除',
          //   align: 'center',
          //   dataIndex: 'deleteFlag',
          //   scopedSlots: { customRender: 'deleteFlag' },
          // }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baCheckoutExamPage(Object.assign(parameter, this.switchingDate())).then((res) => {
           
            res.data.rows.map((item)=>{
              item['realFee'] = (Number(item.chargeFee) - Number(item.refundFee)).toFixed(2)
            })
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('baCheckoutExam:edit') || this.hasPerm('baCheckoutExam:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamcheckoutDate = this.queryParam.billCycleYear
        if (queryParamcheckoutDate != null) {
            this.queryParam.billCycleYear = moment(queryParamcheckoutDate).format('YYYY')
            if (queryParamcheckoutDate.length < 1) {
                delete this.queryParam.billCycleYear
            }
        }
         const queryParambillCycleMonth = this.queryParam.billCycleMonth
        if (queryParambillCycleMonth != null) {
            this.queryParam.billCycleMonth = moment(queryParambillCycleMonth).format('MM')
            if (queryParambillCycleMonth.length < 1) {
                delete this.queryParam.billCycleMonth
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.baCheckoutExamDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.baCheckoutExamDelete(paramIds)
      },
      // 弹出日历和关闭日历的回调
      openChangeOne(status) {
        if (status) {
          this.yearShowOne = true
        }else{
          this.yearShowOne = false
        }
      },
      // 得到年份选择器的值
      panelChangeOne(value) {
        this.queryParam.billCycleYear = value
        this.yearShowOne = false
      },
      baCheckoutExamDelete (record) {
        baCheckoutExamDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      
      onChangecheckoutDate(date, dateString) {
        this.checkoutDateDateString = dateString
      },
      /**
       * 批量导出
       */
      batchExport (record) {
        this.loading = true
        const paramIds = {
          id :record.id
        }
        baCheckoutExamExport(paramIds).then((res) => {
          this.loading = false
          this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less" scoped>
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
